import { Formik } from 'formik';
import { useLegalFormStepsContext } from '../../../../context/LegalFormContext'
import Step2Form from './step2Form';

const Step2 = () => {
  const { nextStep } = useLegalFormStepsContext();

  return (
    <Formik onSubmit={nextStep}>
      <Step2Form/>
    </Formik>
  );
};

export default Step2;
